import LoadingRateCards from "../components/production/LoadingRateCards";

export const loadingRateTabConfigConfig = (data) => {

    const getSum = (object, key) => {
        let sum = 0;
    
        for (const k in data) {
            sum += data[k][object][key];
        }
    
        return sum;
    }

    const getObject = () => {
        return (
            {
                junior: {
                    produced_days: getSum('junior', 'produced_days'),
                    billed_days: getSum('junior', 'billed_days')
                },
                confirmed: {
                    produced_days: getSum('confirmed', 'produced_days'),
                    billed_days: getSum('confirmed', 'billed_days')
                },
                senior: {
                    produced_days: getSum('senior', 'produced_days'),
                    billed_days: getSum('senior', 'billed_days')
                }
            }
        )
    }

    // TABS
    let tabs = [{
        id: 1,
        label: 'Cabinet',
        component: <LoadingRateCards data={getObject()}/>
    }];
    
    for(const key in data) {
                
        const item = {
            id: key,
            label: key,
            component: <LoadingRateCards data={data[key]}/>
        }
    
        tabs.push(item);
    }

    return (
        {
            width: 'w-full',
            height: 'h-auto',
            showCardHeader: false,
            childOverflow: 'overflow-y-auto',
            tapSelectorPosition: 'self-start',
            tabs: tabs
        }
    );
};
